import { SvgIcon, type SvgIconProps } from '../layout/SvgIcon';

export const HomeIcon24: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.953 2.962a.75.75 0 0 0-.53.217h-.001L5.208 9.4v-.311a.75.75 0 0 0-1.265-.545l6.42-6.425.001-.002a2.249 2.249 0 0 1 3.182.01h.001l6.43 6.426a.75.75 0 0 0-1.27.54v.312l-6.222-6.218-.002-.003a.751.751 0 0 0-.53-.221Zm8.255 7.94-1.5-1.498v10.937h-3v-3.75a3.75 3.75 0 1 0-7.5 0v3.75h-3V9.399l-1.5 1.501V9.088c0-.2.078-.38.205-.515l.03-.03-.03.03-2.986 2.988a.75.75 0 1 0 1.062 1.06l1.719-1.72v10.19c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75V10.903Zm-.21-2.33-.02-.02a.705.705 0 0 1 .02.02Zm0 0c.13.136.21.319.21.521v1.81l1.72 1.718a.75.75 0 1 0 1.06-1.06l-2.99-2.988ZM9.708 20.342h-1.5v.75a.75.75 0 0 0 1.5 0v-.75Zm4.5 0h-4.5v-3.75a2.25 2.25 0 0 1 4.5 0v3.75Zm0 0h1.5v.75a.75.75 0 0 1-1.5 0v-.75Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M14.958 21.841a.75.75 0 0 0 .75-.75v-.75h-1.5v.75c0 .414.336.75.75.75ZM8.958 21.841a.75.75 0 0 0 .75-.75v-.75h-1.5v.75c0 .414.336.75.75.75ZM5.208 9.088a.75.75 0 0 0-1.265-.545l-.03.03a.747.747 0 0 0-.205.515V10.9l1.5-1.501v-.311ZM19.458 8.343a.75.75 0 0 0-.75.75v.311l1.5 1.499v-1.81a.748.748 0 0 0-.21-.52l-.02-.02a.747.747 0 0 0-.52-.21Z"
        />
    </SvgIcon>
);
